export var VoucherType;
(function (VoucherType) {
    VoucherType["VA"] = "VA";
    VoucherType["VR"] = "VR";
    VoucherType["VR_VA"] = "VR_VA";
    VoucherType["VA_PAT"] = "VA_PAT";
    VoucherType["VR_PAT"] = "VR_PAT";
})(VoucherType || (VoucherType = {}));
export var ProductFamily;
(function (ProductFamily) {
    ProductFamily["PAT"] = "PAT";
    ProductFamily["AUXILIO"] = "AUXILIO";
})(ProductFamily || (ProductFamily = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["PERCENTAGE"] = "PERCENTAGE";
    DiscountType["TOTAL"] = "TOTAL";
    DiscountType["NO_DISCOUNT"] = "NO_DISCOUNT";
})(DiscountType || (DiscountType = {}));
export var DeliveryModel;
(function (DeliveryModel) {
    DeliveryModel["COMPANY"] = "COMPANY";
    DeliveryModel["BENEFICIARY"] = "BENEFICIARY";
})(DeliveryModel || (DeliveryModel = {}));
export var RechargeDayType;
(function (RechargeDayType) {
    RechargeDayType["FIRST_WORKING_DAY"] = "FIRST_WORKING_DAY";
    RechargeDayType["LAST_WORKING_DAY"] = "LAST_WORKING_DAY";
    RechargeDayType["FIXED_DAY"] = "FIXED_DAY";
})(RechargeDayType || (RechargeDayType = {}));
export var ReleaseType;
(function (ReleaseType) {
    ReleaseType["DAILY"] = "DAILY";
    ReleaseType["MONTHLY"] = "MONTHLY";
})(ReleaseType || (ReleaseType = {}));
export var ContractDetailStatus;
(function (ContractDetailStatus) {
    ContractDetailStatus["PENDING"] = "PENDING";
    ContractDetailStatus["ACTIVE"] = "ACTIVE";
    ContractDetailStatus["INACTIVE"] = "INACTIVE";
})(ContractDetailStatus || (ContractDetailStatus = {}));
